import { AsyncSubject, Observable } from "rxjs";

export class SingleChoice {
  id: number;
  idObservable: Observable<number>;
  label: string;
  backgroundColor: string;
  color: string;
  importance: number;
  constructor(public topic: string) {}

  private subject: AsyncSubject<number>;

  setup(): Observable<number> {
    this.subject = new AsyncSubject();
    return this.subject;
  }

  choose(
    id: number,
    label: string,
    backgroundColor: string,
    color: string,
    importance: number
  ): void {
    this.label = label;
    this.backgroundColor = backgroundColor;
    this.color = color;
    this.importance = importance;
    this.subject.next(id);
    this.subject.complete();
  }
  public static get EMPTY(): SingleChoice {
    return new SingleChoice("");
  }

  public get waiting(): Observable<number> {
    return this.subject;
  }
}
